import { useLogin } from '@tribeplatform/react-components/common'
import { useSubscriptionInformation } from '@tribeplatform/react-sdk/hooks'

export const useTrialInformation = () => {
  const { isLoggedIn } = useLogin()

  const {
    data: subscriptionInformation,
    isLoading: subscriptionInformationLoading,
  } = useSubscriptionInformation({
    useQueryOptions: {
      enabled: isLoggedIn,
    },
  })

  return {
    isLoading: isLoggedIn && subscriptionInformationLoading,
    isLoggedIn,
    isManual: subscriptionInformation?.isManual ?? false,
    isTrial: subscriptionInformation?.isTrial ?? false,
    isActive: subscriptionInformation?.isActive ?? false,
    trialEndDate: subscriptionInformation?.trialEndDate ?? null,
  }
}
